// extracted by mini-css-extract-plugin
export var fadeInAnimation = "YoutubePlayer-module--fadeInAnimation--172c9";
export var hidden = "YoutubePlayer-module--hidden--4a2aa";
export var mediaPlayer = "YoutubePlayer-module--mediaPlayer--6ab65";
export var modal = "YoutubePlayer-module--modal--e94af";
export var video = "YoutubePlayer-module--video--8b6bf";